import TalentProfile from "../../components/Profile/TalentProfile";
import { useErrorResponse } from "../../hooks/useErrorResponse";
import { useGetATalent } from "../../services/api/talent.api";
import { User } from "../../types/user";
import React from "react";
import { useParams } from "react-router-dom";

const TalentPage = () => {
  const { id } = useParams();
  const {
    data: talent,
    isLoading,
    error,
  } = useGetATalent({
    options: {
      enabled: !!id,
    },
    params: {
      id: parseInt(id!),
    },
    key: ["talent", id],
  });

  useErrorResponse(error);

  const userInfo = {
    first_name: talent?.data?.user?.first_name ?? "",
    last_name: talent?.data?.user?.last_name ?? "",
  };
  return (
    <>
      {talent?.data && (
        <TalentProfile userInfo={userInfo as User} talentInfo={talent.data} />
      )}
    </>
  );
};

export default TalentPage;
